import React, { useState } from 'react';
import sanitizeHtml from 'sanitize-html';

import { LinkButton } from '@eika/button';
import { Icon, IconTypes } from '@eika/icon';
import { Modal } from '@eika/modal';

import { useTranslation } from '../../../translations';

import './AntiMoneyLaunderingTask.scss';

interface AntiMoneyLaunderingTaskInterface {
    cardBodyText: string;
    linkLabelText: string;
    linkContentText: string;
    oppfolgingUrl: string;
}
const AntiMoneyLaunderingTask = ({
    cardBodyText,
    linkLabelText,
    linkContentText,
    oppfolgingUrl,
}: AntiMoneyLaunderingTaskInterface) => {
    const { task, antiMoneyLaunderingTask } = useTranslation();
    const [showModal, setShowModal] = useState(false);
    return (
        <>
            <div className="anti-money-laundering-tasks">
                <span className="anti-money-laundering-tasks__title typography-subtitle">{task.tasksTitle}</span>
                <div className="anti-money-laundering-tasks__list">
                    <a className="anti-money-laundering-task-link" href={oppfolgingUrl}>
                        <Icon
                            type={IconTypes.CHECKMARK_TIL_SIRKEL_24}
                            wrapperClassName="anti-money-laundering-task-link__checkmark-icon"
                        />
                        <div className="anti-money-laundering-task-link__text-wrapper">
                            <div className="typography-subtitle">{antiMoneyLaunderingTask.taskTitle}</div>
                            <span className="typography-small">{cardBodyText}</span>
                        </div>
                        <Icon
                            className="anti-money-laundering-task-link-arrow-icon icon--24"
                            type={IconTypes.PIL_HOEYRE}
                        />
                    </a>
                    <LinkButton onClick={() => setShowModal(true)} icon={IconTypes.SPOERSMAAL_24}>
                        {linkLabelText}
                    </LinkButton>
                </div>
            </div>
            <Modal open={showModal} setOpen={setShowModal} title={antiMoneyLaunderingTask.title}>
                <div dangerouslySetInnerHTML={{ __html: sanitizeHtml(linkContentText) }} />
            </Modal>
        </>
    );
};

export default AntiMoneyLaunderingTask;
